import React from 'react';
import {Box, Tab, Tabs} from '@mui/material';

const SuggestiveSellingCategoryTabs = ({
                                           groups,
                                           activeGroupId,
                                           onChange,
                                       }) => (
    <Box sx={{borderBottom: 1, borderColor: 'divider', mb: 2}}>
        <Tabs
            value={activeGroupId}
            onChange={(_, value) => onChange(value)}
            variant={'scrollable'}
            scrollButtons={'auto'}
        >
            {
                groups.map((group) => (
                    <Tab
                        key={group.id}
                        value={group.id}
                        label={group.relationTypeTitle ?? group.id}
                    />
                ))
            }
        </Tabs>
    </Box>
);

export default SuggestiveSellingCategoryTabs;
